export const tableData = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '减分项',
    },
    {
      key: 'extraid',
      dataIndex: 'extraid',
      title: '关联指标',
    },
    {
      key: 'scorelabel',
      title: '建议减分专家',
      dataIndex:'scorelabel',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
